/**
 * Status colors aligned with iris-tokens.css semantic status tokens.
 *
 * RGB triplets match the --iris-neon-* hex values from iris-tokens.css:
 *   healthy  → --iris-neon-green   #39ff88 → 57, 255, 136    token-exempt
 *   warning  → --iris-neon-orange  #ff9933 → 255, 153, 51    token-exempt
 *   critical → --iris-neon-pink    #ff4dd2 → 255, 77, 210    token-exempt
 */
export type Status = "healthy" | "warning" | "critical" | "unknown";

export const STATUS_RGB: Record<Status, string> = {
  healthy: "57, 255, 136",
  warning: "255, 153, 51",
  critical: "255, 77, 210",
  // IR-1771: no status reported yet. Neutral grey, never the healthy green.
  unknown: "139, 148, 158",
};

const CSS_VAR = "--status-rgb";

export function setStatus(next: Status): void {
  document.documentElement.style.setProperty(CSS_VAR, STATUS_RGB[next]);
}

export function getStatus(): Status {
  const rgb = document.documentElement.style.getPropertyValue(CSS_VAR);
  if (rgb) {
    for (const key of Object.keys(STATUS_RGB) as Status[]) {
      if (STATUS_RGB[key] === rgb) return key;
    }
  }
  return "healthy";
}
